export interface EmployeePersonalContact {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy: CreatedBy;
  addressType: string;
  phoneCode?: string;
  phoneNumber: string;
  address: string;
  countryId: number;
  provinceId: number;
  districtId: number;
  wardId: number;
  employeeId: number;
  organizationId: number;
  country: Country;
  province: Country;
  district: Country;
  ward: Country;
}

interface Country {
  id: number;
  code: string;
  name: string;
  nativeName: string;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface EmployeePersonalContactListRequest {
  employeeId: number;
}

export interface EmployeePersonalContactCreateRequest {
  employeeId: number;
  addressType: string;
  phoneCode?: string;
  phoneNumber: string;
  address: string;
  countryId: number;
  provinceId: number;
  districtId: number;
  wardId: number;
}

export interface EmployeePersonalContactUpdateRequest
  extends EmployeePersonalContactCreateRequest {
  id: string;
}

export interface EmployeePersonalContactListResponse
  extends RestAPIMetaResponse {
  items: Array<EmployeePersonalContact>;
}

export enum EmployeePersonalContactAddressType {
  Permanent = "Permanent",
  Temporary = "Temporary",
}
